import _objectWithoutProperties from "/home/bamboo/bamboo-agent-home/xml-data/build-dir/WEC-SIN33-JOB1/packages/web/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["title", "titleId"];
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
function Checklist(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 16,
    height: props.size || 16,
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M7.115 17.938a.998.998 0 01-.006 1.414l-2.713 2.69a1 1 0 01-.704.29h-.006a1 1 0 01-.707-.297l-1.447-1.47a.999.999 0 111.425-1.404l.743.755 2.001-1.985a1 1 0 011.414.006zm14.9 1.049a1 1 0 010 2H10.917a1 1 0 010-2h11.098zM4.325 9.08a3.33 3.33 0 013.325 3.325 3.33 3.33 0 01-3.325 3.325A3.33 3.33 0 011 12.406a3.33 3.33 0 013.325-3.325zm0 2c-.73 0-1.325.594-1.325 1.325s.595 1.325 1.325 1.325 1.325-.594 1.325-1.325-.595-1.325-1.325-1.325zm17.69.325a1 1 0 010 2H10.917a1 1 0 010-2h11.098zM4.325 1.5A3.33 3.33 0 017.65 4.825 3.329 3.329 0 014.325 8.15 3.329 3.329 0 011 4.825 3.33 3.33 0 014.325 1.5zm0 2C3.595 3.5 3 4.094 3 4.825S3.595 6.15 4.325 6.15 5.65 5.556 5.65 4.825 5.055 3.5 4.325 3.5zm17.69.325a1 1 0 010 2H10.917a1 1 0 010-2h11.098z",
    fill: props.color || "#222",
    fillRule: "evenodd"
  }));
}
var MemoChecklist = React.memo(Checklist);
export default MemoChecklist;